import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { EllipsisTooltipText } from "../../../common/components/EllipsisTextWithTooltip";
import Draggable from "react-draggable";

export const ReferenceFieldsModal = ({
    fieldValue,
    onCancel,
    heading,
    hideHeader = false,
    showSaveAction = false,
    onSaveValue,
    getSaveDisabledReason,
    onEditValue
}) => {
    const [copySuccess, setCopySuccess] = useState(null);

    const handleCopy = label => {
        setCopySuccess(label);
        setTimeout(() => setCopySuccess(null), 2000);
    };
    const allCols = Object.keys(fieldValue?.[0] || {});
    return (
        <div className="modal analyse_reference_modal" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <Draggable handle=".draggable" cancel=".not-draggable">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title">{heading}</h5>
                            <button type="button" className="close" onClick={onCancel}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body analyse_reference_body not-draggable">
                            {Array.isArray(fieldValue) && fieldValue.length > 0 ? (
                                <div className="table-responsive">
                                    <table className="analyse_reference_table">
                                        {!hideHeader && (
                                            <thead>
                                                <tr>
                                                    {Object.keys(fieldValue?.[0])?.map(col => (
                                                        <th key={col}>
                                                            {col
                                                                ?.toString()
                                                                ?.replace(/_/g, " ")
                                                                .replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1))}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                        )}
                                        <tbody>
                                            {fieldValue.map((item, index) => (
                                                <tr key={index} className="">
                                                    {allCols.map(key => {
                                                        let val = item?.[key];
                                                        const displayVal =
                                                            val === null || val === undefined || val === ""
                                                                ? "-"
                                                                : typeof val === "string" || typeof val === "boolean"
                                                                  ? val?.toString()
                                                                  : "";
                                                        const isUrl = typeof displayVal === "string" && /^(https?:\/\/[^\s]+)/.test(displayVal);
                                                        const saveDisabledReason =
                                                            typeof getSaveDisabledReason === "function"
                                                                ? getSaveDisabledReason(displayVal, key, item, index)
                                                                : "";
                                                        const canSaveValue =
                                                            showSaveAction &&
                                                            typeof onSaveValue === "function" &&
                                                            displayVal &&
                                                            displayVal !== "-" &&
                                                            !saveDisabledReason;
                                                        return (
                                                            <td key={key} className={hideHeader ? "mr-1" : ""}>
                                                                <div className="url-wrp">
                                                                    {isUrl ? (
                                                                        <a href={displayVal} target="_blank" rel="noopener noreferrer">
                                                                            <EllipsisTooltipText text={displayVal ?? ""} />
                                                                        </a>
                                                                    ) : typeof displayVal === "object" && displayVal !== null ? (
                                                                        <EllipsisTooltipText text={JSON.stringify(displayVal) ?? ""} />
                                                                    ) : (
                                                                        <EllipsisTooltipText text={displayVal ?? ""} />
                                                                    )}
                                                                    {!displayVal || displayVal === "-" ? (
                                                                        <div
                                                                            className="icon ai-copy cursor-diabled"
                                                                            style={{ cursor: "not-allowed" }}
                                                                        >
                                                                            <i
                                                                                className="fa fa-copy"
                                                                                data-tip="No value to copy"
                                                                                data-for="Asset_details"
                                                                                data-place="left"
                                                                                style={{ color: "#4B90FA" }}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <CopyToClipboard
                                                                            text={displayVal?.replace(
                                                                                /\s*\(\s*(?:image|web)(?:\s*\|\s*(?:image|web))?\s*\)/gi,
                                                                                ""
                                                                            )}
                                                                            onCopy={() => handleCopy(`${index}_${key}`)}
                                                                        >
                                                                            <div className="rt-data" style={{ cursor: "pointer" }}>
                                                                                {copySuccess === `${index}_${key}` ? (
                                                                                    <i className="fa fa-check" style={{ color: "green" }} />
                                                                                ) : (
                                                                                    <i className="fa fa-copy" style={{ color: "#4B90FA" }} />
                                                                                )}
                                                                            </div>
                                                                        </CopyToClipboard>
                                                                    )}
                                                                    {showSaveAction && (
                                                                        <div
                                                                            className={`rt-data ml-2 ${
                                                                                canSaveValue ? "cursor-hand" : "cursor-diabled"
                                                                            }`}
                                                                            style={{ cursor: canSaveValue ? "pointer" : "not-allowed" }}
                                                                            data-tip={
                                                                                !displayVal || displayVal === "-"
                                                                                    ? "No value"
                                                                                    : saveDisabledReason || "Save"
                                                                            }
                                                                            data-for="Asset_details"
                                                                            data-place="left"
                                                                            onClick={() => {
                                                                                if (canSaveValue) onSaveValue(displayVal);
                                                                            }}
                                                                        >
                                                                            <img
                                                                                className="original-asset-value-save"
                                                                                src="/img/Green 1.svg"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    {showSaveAction && typeof onEditValue === "function" && (
                                                                        <i
                                                                            className={`fa fa-pencil-alt ml-2 ai-edit-icon ${
                                                                                saveDisabledReason ? "cursor-disabled" : "cursor-hand"
                                                                            }`}
                                                                            style={{ color: "#4B90FA" }}
                                                                            data-tip={saveDisabledReason || "Edit"}
                                                                            data-for="Asset_details"
                                                                            data-place="left"
                                                                            onClick={() => {
                                                                                if (!saveDisabledReason)
                                                                                    onEditValue(displayVal === "-" ? "" : displayVal);
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <p>No data available</p>
                            )}
                        </div>
                    </div>
                </Draggable>
            </div>
        </div>
    );
};
